import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';

import Header from '../decoration/header';
import Footer from '../footer/footer';

import './ourClient.css';

class OurClient extends Component {
	render() {
		return (
			<div>
				<Header/>
				<div id='banner'>OUR CLIENTS</div>
				<h3 id="ourClientContentTitle"><b>CLIENT LISTING</b></h3>

				<Row id="ourClientContent" className="show-grid">
			    <Col xs={6} md={4}>
						<div id="column1">
								American Express<br/>
								Audemars Piguet<br/>
								Asia Pacific Properties Limited<br/>
								Bank J. Safra Sarasin Limited, <br/>Hong Kong Branch<br/>
								Bally GC Retail Co Limited<br/>
								Bentley Hong Kong<br/>
								Carlson Watch Co. Ltd.<br/>
								Cartier<br/>
								Chanel<br/>
								Charriol<br/>
								Chin. G<br/>
								Christian Dior<br/>
								Citigroup<br/>
								Clé de Peau Beauté<br/>
								CLSA Limited<br/>
								Credit Suisse Private Banking<br/>
								Cuisine Cuisine 國金軒<br/>
								Deutsche Bank AG, Hong Kong<br/>
								DIANE von FURSTENBERG<br/>
								Drop
						</div>
			    </Col>
			    <Col xs={6} md={4}>
						<div id="column2">
								Elegant Watch & Jewellery Co. Ltd.<br/>
								Emperor Watch & Jewllery<br/>
								Estee Lauder<br/>
								FENDI Asia Pacific<br/>
								Forevermark<br/>
								Franck Muller Geneve<br/>
								Giorgio Armani Beauty<br/>
								Gucci<br/>
								H One<br/>
								Hair Corner<br/>
								Hang Seng Bank<br/>
								Headquarters<br/>
								Helena Rubinstein<br/>
								HONDA<br/>
								HUGO BOSS<br/>
								HSBC<br/>
								Italian Trade Commission<br/>
								Jimmy Choo<br/>
								JP Morgan<br/>
								KEE Club<br/>
								Kinwick Centre<br/>
								L’Oreal<br/>
								La Mer<br/>
								la prairie<br/>
								Lancome<br/>
								Lan Kwai Fong Entertainments<br/>
								Lane Crawford<br/>
								LANEIGE<br/>
								LOEWE<br/>
								Louis Vuitton (LVMH)<br/>
								M1NT
						</div>
			    </Col>
			    <Col xsHidden md={4}>
						<div id="column3">
								Mercedes-Benz<br/>
								Morgan Stanley<br/>
								NARS<br/>
								National Bank of Abu Dhabi<br/>
								NEO DERM<br/>
								Novotel Century Hong Kong Hotel<br/>
								On Pedder<br/>
								Parmigiani Fleurier<br/>
								Paspaley<br/>
								PATRIZIA PEPE<br/>
								Pearl on the Peak<br/>
								Piaget<br/>
								Ralph Lauren<br/>
								Quintessentially (HK) Limited<br/>
								ROLEX<br/>
								Shiseido Dah Chong Hong Cosmetics Ltd.<br/>
								SISLEY<br/>
								SK II<br/>
								Sotheby’s<br/>
								Swarovski<br/>
								The Ambition Group Ltd.<br/>
								The French Window<br/>
								The Mira<br/>
								The Philippa Huckle Group<br/>
								The Ritz-Carlton, Hong Kong<br/>
								The Venetian Macao Resort Hotel<br/>
								TOD’S<br/>
								UBS<br/>
								Vacheron Constantin<br/>
								Valentino<br/>
								Van Cleef & Arpels<br/>
								Versace<br/>
								Wagyu<br/>
								Yves Saint Laurent Beauté
						</div>
			    </Col>
			  </Row>

				<Footer/>
			</div>
		)
	}
}

export default OurClient;



// WEBPACK FOOTER //
// ./src/components/ourClient/ourClient.js